import { BLUE, CYAN, LIME_GREEN, ORANGE, PINK, PURPLE, RED } from "./colors";

// Category -> color, shared by DashboardCard's pill and Settings' Engagement category dots. Same
// hex values, by design, as cedar-backend's own backfill migration for _dashboard_category.color
// (alembic/versions/0f50b45c4b00_add_dashboard_category_color.py) - keeps a category's
// collapsible-arrow chevron (colored from that column) and its pill/dot here (colored from this
// map, by name) reading as the same color for the same category.
// "VerbatimAnalysis" doesn't correspond to any current SEARCHABLE_DASHBOARDS category but is
// included for forward-compatibility, per the exact color spec given for the Favourites/Dashboards
// cards.
export const CATEGORY_COLORS: Record<string, string> = {
  "Customer Experience": ORANGE,
  AMIEO: PINK,
  "Marketing Intelligence": PURPLE,
  "Connected Car Services": LIME_GREEN,
  "Marketing and Sales": RED,
  VerbatimAnalysis: BLUE,
};

export const DEFAULT_CATEGORY_COLOR = CYAN;
